<template>
  <div>
    <div class="app-main__inner">
      <TituloComponente
        icono-titulo="fas fa-clipboard-list"
        texto-titulo="Obra Social"
        :to-create-action="{ name: 'NuevaObraSocial' }"
        to-create-text="Nueva Obra Social"
      />
      <div class="tab-content">
        <div
          class="tab-pane tabs-animation fade show active"
          id="tab-content-0"
          role="tabpanel"
        >
          <div class="row">
            <div class="col-lg-12">
              <div class="main-card mb-3 card">
                <div class="card-body">
                  <h5 class="card-title">Listado de Obras Sociales</h5>
                  <DataList
                    ref="datatable"
                    url="/obrasocial"
                    :fields="fields"
                    :rowClick="mostrarOpciones"
                  ></DataList>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TituloComponente from "@/components/layouts/TituloComponente";
import axios from "axios";
import DataList from "@/components/layouts/DataList";
import Swal from "sweetalert2";
export default {
  name: "ListarObraSocial",
  components: {
    TituloComponente,
    DataList,
  },
  data() {
    return {
      obraSocial: [],
      fields: [
        {
          name: "codigo",
          label: "",
          type: "title",
          class: "",
          append: "-",
        },
        {
          name: "descripcion",
          label: "",
          type: "title",
          class: "",
        },
        {
          name: "codigo_afip",
          label: "Codigo afip",
          type: "field",
          class: "",
        },
      ],
    };
  },
  created() {},
  mounted() {},
  methods: {
    mostrarOpciones(obraSocial) {
      Swal.fire({
        title: obraSocial.descripcion,
        showCancelButton: true,
        confirmButtonText: "Editar",
        cancelButtonText: "Eliminar",
        confirmButtonColor: "#f7b924",
        cancelButtonColor: "#d33",
        reverseButtons: true,
      }).then((result) => {
        if (result.value) {
          this.$router.push({
            name: "EditarObraSocial",
            params: { id: obraSocial.id },
          });
        } else if (
          /* Read more about handling dismissals below */
          result.dismiss === Swal.DismissReason.cancel
        ) {
          this.eliminarObraSocial(obraSocial);
        }
      });
    },
    eliminarObraSocial(obraSocial) {
      Swal.fire({
        title: "¿Estás seguro?",
        text: `¿Deseas eliminar ${obraSocial.descripcion} de manera permanente?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.value) {
          this.loading = true;
          axios
            .delete("obrasocial/" + obraSocial.id)
            .then((res) => {
              Swal.fire(
                "Eliminado",
                `${res.data.obrasocial.descripcion} se ha eliminado con éxito.`,
                "success"
              );
              console.log(this.$refs);
              this.$refs.datatable.update();
            })
            .catch((err) => console.log(err))
            .finally(() => (this.loading = false));
        }
      });
    },
  },
};
</script>
